import { toast } from "react-toastify";
import { useMutation } from "@apollo/client/react";
import { useTranslation } from "react-i18next";
import { CustomToastComponent } from "@/components/shared";
import {
  UpdateAdvancedCostParametersMutation,
  UpdateAdvancedCostParametersMutationVariables,
  UpdateAdvancedCostParametersDocument,
} from "@/graphql/__generated__/graphql";

/**
 * Custom hook for updating advanced cost parameters and handling the necessary cache updates.
 * @returns {Object} - Contains the updateAdvancedCostParameterMutation function, loading state, and error state.
 */
export default function useUpdateAdvancedCostParametersMutationHook(): {
  updateAdvancedCostParameterMutation: any;
  loading: any;
  error: any;
  } {
  const { t } = useTranslation(["toasts"]);

  const [updateAdvancedCostParameterMutation, { loading, error }] = useMutation<UpdateAdvancedCostParametersMutation, UpdateAdvancedCostParametersMutationVariables>(
    UpdateAdvancedCostParametersDocument, {
      onCompleted() {
        toast(CustomToastComponent, {
          toastId: "advanced-cost-parameters-updated-success",
          data: {
            title: t("toasts.advancedcostparametersupdated"),
            type: "success",
          },
        });
      },
    });

  return {
    updateAdvancedCostParameterMutation,
    loading,
    error,
  };
}
